import { render, staticRenderFns } from "./CreateThory.vue?vue&type=template&id=7ddae8ca&scoped=true&"
import script from "./CreateThory.vue?vue&type=script&lang=js&"
export * from "./CreateThory.vue?vue&type=script&lang=js&"
import style0 from "./CreateThory.vue?vue&type=style&index=0&id=7ddae8ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddae8ca",
  null
  
)

export default component.exports